import { render, staticRenderFns } from "./ClusterLogos.vue?vue&type=template&id=2558a424"
import script from "./ClusterLogos.vue?vue&type=script&lang=js"
export * from "./ClusterLogos.vue?vue&type=script&lang=js"
import style0 from "./ClusterLogos.vue?vue&type=style&index=0&id=2558a424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports